import {getNodeResourceData, getStowBagMetrics, getStowBins, getStowPackageMetrics} from "../resources/StowResource";
import {getInductPackageMetrics} from "../resources/InductResource";
import {publishCount, publishTime} from "../MetricUtility";
import {CYCLE, CYCLE_ID, ERROR_METRIC_SUFFFIX, FALSE, True} from "../constants";
import {BagMetric, InductPackageMetric, Resource, StowPackageMetric} from "../enums";

export const LOAD_METRICS_FOR_SORT_ZONE_CALL_BEGIN = "LOAD_METRICS_FOR_SORT_ZONE_CALL_BEGIN";
export const LOAD_STOW_PACKAGE_METRICS_FOR_SORT_ZONE = "LOAD_STOW_PACKAGE_METRICS_FOR_SORT_ZONE";
export const LOAD_STOW_BAG_METRICS_FOR_SORT_ZONE = "LOAD_STOW_BAG_METRICS_FOR_SORT_ZONE";
export const LOAD_STOW_CART_METRICS_FOR_SORT_ZONE = "LOAD_STOW_CART_METRICS_FOR_SORT_ZONE";
export const LOAD_STOW_OV_USAGE_FOR_SORT_ZONE = "LOAD_STOW_OV_USAGE_FOR_SORT_ZONE";
export const LOAD_STOW_BAG_DATA_FOR_SORT_ZONE = "LOAD_STOW_BAG_DATA_FOR_SORT_ZONE";
export const LOAD_INDUCT_PACKAGE_METRICS_FOR_SORT_ZONE = "LOAD_INDUCT_PACKAGE_METRICS_FOR_SORT_ZONE";
export const LOAD_METRICS_FOR_SORT_ZONE_CALL_FAILURE = "LOAD_METRICS_FOR_SORT_ZONE_CALL_FAILURE";
export const LOAD_NODE_RESOURCE_DATA_FOR_SORT_ZONE = "LOAD_NODE_RESOURCE_DATA_FOR_SORT_ZONE";
export const LOAD_TOTAL_SORT_ZONE = "LOAD_TOTAL_SORT_ZONE";

const metricProcessName = "SCC_STOW_SORTZONE";

const loadMetricsForSortZoneCallBegin = () => ({
    type: LOAD_METRICS_FOR_SORT_ZONE_CALL_BEGIN
});

const loadInductPackageMetricsForSortZone = (inductPackageMetricsMap) => ({
    type: LOAD_INDUCT_PACKAGE_METRICS_FOR_SORT_ZONE,
    inductPackageMetricsMap
});

const loadNodeResourceDataForSortZone = (nodeResourceData) => ({
    type :LOAD_NODE_RESOURCE_DATA_FOR_SORT_ZONE,
    nodeResourceData
});

const loadStowPackageMetricsForSortZone = (stowPackageMetricsMap) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_SORT_ZONE,
    stowPackageMetricsMap
});

const loadStowBagMetricsForSortZone = (stowBagMetricsMap) => ({
    type: LOAD_STOW_BAG_METRICS_FOR_SORT_ZONE,
    stowBagMetricsMap
});

const loadStowOvUsageForSortZone = (stowOvUsageMap) => ({
    type: LOAD_STOW_OV_USAGE_FOR_SORT_ZONE,
    stowOvUsageMap
});

const loadStowBagDataForSortZone = (stowBagsData) => ({
    type: LOAD_STOW_BAG_DATA_FOR_SORT_ZONE,
    stowBagsData
});

const loadMetricsForSortZoneCallFailure = () => ({
    type: LOAD_METRICS_FOR_SORT_ZONE_CALL_FAILURE
});

export const getStowPackageMetricsForSortZone = (isDRSStowVisibilityEnabled, nodeId, cycles, aisles, cycleIds) => {

    const metricName = "getStowPackageMetrics";

    const request = {
        groupBy: Resource.BIN,
        filters: {
            NODE: [nodeId],
            AISLE: aisles
        },
        metrics: [
            StowPackageMetric.STOWED_COUNT,
            StowPackageMetric.PLANNED_COUNT,
            StowPackageMetric.CURRENT_INDUCTED_COUNT
        ]
    }

    if (!isDRSStowVisibilityEnabled) {
        request.filters["DRS"] = [FALSE]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForSortZoneCallBegin());
            const startTime = Date.now();
            const stowPackageMetricsMap = await getStowPackageMetrics(request);
            if (stowPackageMetricsMap) {
                dispatch(loadStowPackageMetricsForSortZone(stowPackageMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForSortZoneCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForSortZoneCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowPackageMetricsForSortZoneV2 = (isDRSStowVisibilityEnabled, nodeId, cycles, aisles, floorLocations, cycleIds) => {

    const metricName = "getStowPackageMetricsV2";

    const request = {
        groupBy: Resource.BIN,
        filters: {
            NODE: [nodeId],
            AISLE: aisles,
            FLOOR_LOCATION_V2: floorLocations
        },
        metrics: [
            StowPackageMetric.STOWED_COUNT,
            StowPackageMetric.PLANNED_COUNT,
            StowPackageMetric.CURRENT_INDUCTED_COUNT
        ]
    }

    if (!isDRSStowVisibilityEnabled) {
        request.filters["DRS"] = [FALSE]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForSortZoneCallBegin());
            const startTime = Date.now();
            const stowPackageMetricsMap = await getStowPackageMetrics(request);
            if (stowPackageMetricsMap) {
                dispatch(loadStowPackageMetricsForSortZone(stowPackageMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForSortZoneCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForSortZoneCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const fetchOvUsageForSortZone = (nodeId, cycles, aisles) => {

    const metricName = "getStowOvUsage";

    const request = {
        filters: {
            NODE: [nodeId],
            AISLE: aisles,
        },
        fieldsRequired: ["OV_USAGE"]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForSortZoneCallBegin());
            const startTime = Date.now();
            const stowBinsWithOvUsage = await getStowBins(request);
            if (stowBinsWithOvUsage) {
                dispatch(loadStowOvUsageForSortZone(transformOvUsageResponse(stowBinsWithOvUsage)));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForSortZoneCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForSortZoneCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }

    function transformOvUsageResponse(stowBinsWithOvUsage) {
        const metricsMapOutput = {};
        for (const bin of stowBinsWithOvUsage) {
            metricsMapOutput[bin.binLabel] = {
                ovUsage: bin.ovUsage
            };
        }
        return metricsMapOutput;
    }
}

export const getNodeResourceDataForSortZone = (nodeId, nodeResourceType, aisle) => {
    const metricName = "getNodeResourceData";
    const request = {
        nodeId : nodeId,
        filters: {
            AISLE : aisle
        },
        nodeResourceType :nodeResourceType
    }
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForSortZoneCallBegin());
            const startTime = Date.now();
            const nodeResources = await getNodeResourceData(request);
            if (nodeResources) {
                dispatch(loadNodeResourceDataForSortZone(nodeResources));
                publishTime(metricProcessName, metricName, startTime);
            }
        } catch (error) {
            dispatch(loadMetricsForSortZoneCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
};

export const fetchBagsDataForSortZone = (nodeId, cycles, sortZone) => {

    const metricName = "getStowBags";

    const request = {
        filters: {
            NODE: [nodeId],
            BIN: [sortZone]
        }
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForSortZoneCallBegin());
            const startTime = Date.now();
            const stowBagsData = await getStowBins(request);
            if (stowBagsData && stowBagsData.length && stowBagsData[0].bags) {
                dispatch(loadStowBagDataForSortZone({sortZone: sortZone, bagsData: stowBagsData[0].bags}));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForSortZoneCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForSortZoneCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowBagMetricsForSortZone = (nodeId, cycles, aisles, cycleIds, isStowBreakdownV2Enabled) => {

    const metricName = "getStowBagMetrics";

    const request = {
        groupBy: Resource.BIN,
        filters: {
            NODE: [nodeId],
            AISLE: aisles
        },
        metrics: [
            BagMetric.CLOSED_BAG_COUNT,
            BagMetric.OPEN_BAG_COUNT,
            BagMetric.PLANNED_BAG_COUNT
        ]
    }

    if (isStowBreakdownV2Enabled) {
        request.filters["STOW_BREAKDOWN_V2"] = [True]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForSortZoneCallBegin());
            const startTime = Date.now();
            const stowBagMetricsMap = await getStowBagMetrics(request);
            if (stowBagMetricsMap) {
                dispatch(loadStowBagMetricsForSortZone(stowBagMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForSortZoneCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForSortZoneCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}


export const getInductPackageMetricsForSortZone = (nodeId, cycles, aisles) => {

    const metricName = "getInductPackageMetrics";

    const request = {
        groupBy: "SortZone",
        filters: {
            Aisle: aisles
        },
        metricList: [InductPackageMetric.RECEIVED],
        nodeId: nodeId
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters["Cycle"] = cycles;
    }
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForSortZoneCallBegin());
            const startTime = Date.now();
            const inductPackageMetricsMap = await getInductPackageMetrics(request);
            if (inductPackageMetricsMap) {
                dispatch(loadInductPackageMetricsForSortZone(inductPackageMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForSortZoneCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForSortZoneCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/SortZoneActions.js